<section id="about">
	<br/>
  <i class="fas fa-info speaker-icon text-center"></i>
  <h2 class="section-heading">About</h2>

  <p>This conference is a part of our Ministry of Education, India funded sponsored project under the Scheme for Promotion of Academic and Research Collaboration (SPARC).
The Scheme for Promotion of Academic and Research Collaboration (SPARC) aims at improving the research ecosystem of India’s Higher Educational Institutions by facilitating academic and research collaborations between Indian Institutions and the best institutions in the world from 28 selected nations to jointly solve problems of national and/or international relevance.<br/>
The scheme proposes to enable productive academic co-operation by supporting the following critical components that can catalyze impact making research, namely: Visits and long-term stay of top international faculty / researchers in Indian institutions to pursue teaching and research; Visits by Indian students for training and experimentation in premier laboratories worldwide; Joint development of niche courses, world-class books and monographs, translatable patents, demonstrable technologies or action research outcomes and products; Consolidation of Bilateral co-operation through academic and research partnerships through Indo-X Workshops in India; Publication, Dissemination and Visibility through a high profile annual international Conference in India; The expected outcomes include tangible results in terms of large quantity of high quality research publications, solution to key national and international problems, development of niche courses, high quality text books and research monographs, imbibing of best practices from top international academicians and researchers, strong bilateral co-operation, and improved world reputation and ranking of Indian Institutions.<br/>
Based on our project “Next generation Alloys through Additive Manufacturing” under the SPARC, a significant knowledge sharing among NTNU, Norway, Tallinn University of Technology, Estonia and National Institute of Technology Tiruchirappalli, India has happened. Expert visits from both NTNU and TUT enriched the work happening at NIT Trichy in the cited area.<br/>
Under the aegis of SPARC project, the International Conference on Additive Manufacturing and Allied Technologies (ICAMAT) has been scheduled during June 10 & 11, 2021.</p>
</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
</style>
